export default __webpack_public_path__ + "static/media/ceo.c974a030.png";